<template>
  <div class="vkb_nak vkb_nak_fsoel vkb_nak_jule_2018">
    <div ref="heading" class="large-12 columns">
      <!-- start row: card list -->
      <div class="row tk-vkb-fullsizebg1 tk-vkb-expand">
        <div class="wrapper-spacing large-12 medium-12 small-12 columns">
          <div class="row">
            <div class="small-12 columns">
              <h1>Welchen Schritt planen Sie in Ihrem Leben als nächstes?</h1>
            </div>
          </div>
          <div class="row tk-vkb-flex-container">
            <div v-for="(card, index) in cards" :key="index" class="tk-vkb-cardspace small-12 medium-6 large-3 columns tk-vkb-flex-wrapper">
              <div :class="['cards cards-main text-hyphens', {'active': cardIndex === card.index}]" @click="onSelectCard(card)">
                <div class="cards-image">
                  <asset-image :name="card.iconName" :local-path="card.iconName"/>
                  <!-- <img :class="{'img-active': cardIndex === card.index}" :src="hasAssetPath ? assetPath(card.icon) : cardIcon[index]"> -->
                </div>
                <div class="cards-text">
                  <p class="h4">{{ card.title }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- stop row: card list -->

      <!-- start row: formular -->
      <div ref="housing" class="row">
        <template v-if="cardIndex > 0">
          <div class="wrapper-spacing small-12 medium-10 large-12 columns">
            <h2>{{ cards[cardIndex-1].title }}</h2>
            <p class="color-primary">Treffen Sie bitte eine Auswahl</p>
          </div>

          <div class="small-12 columns">
            <hr v-if="cardIndex !== 3" class="topspace">
            <div v-if="cardIndex !== 3" class="row form-spacing">
              <div class="large-6 medium-5 small-12 columns form-break-spacing">
                <h3 class="feedback">
                  <span :class="['feedback-before', {'validated': housingIndex > 0}]"/>Meine Wohnsituation
                </h3>
              </div>
              <div class="large-6 medium-7 small-12 columns">
                <div class="radio-wrapper left-wrapper-50">
                  <input id="eltern" :checked="housingIndex === 1" type="radio" name="room" value="1" class="radio" @change="(e) => onSelectHousing(e, '02/wohnsituation/eltern')">
                  <label for="eltern">bei den Eltern</label>
                </div>
                <div class="radio-wrapper right-wrapper-50">
                  <input id="wohnung" :checked="housingIndex === 2" type="radio" name="room" value="2" class="radio" @change="(e) => onSelectHousing(e, '02/wohnsituation/eigene_wohnung')">
                  <label for="wohnung">eigene Wohnung</label>
                </div>
              </div>
            </div>

            <hr v-if="cardIndex === 2 || cardIndex === 3">

            <div v-if="cardIndex === 2 || cardIndex === 3" class="row form-spacing">
              <div class="large-6 medium-5 small-12 columns form-break-spacing">
                <h3 class="feedback"><span :class="['feedback-before', {'validated': educationIndex > 0}]"/>Meine Bildungs- oder Berufssituation</h3>
              </div>
              <div class="large-6 medium-7 small-12 columns">
                <div class="radio-wrapper left-wrapper-50">
                  <input id="ausbildung" :checked="educationIndex === 1" type="radio" name="education" value="1" class="radio" @change="(e) => onSelectEducation(e, '02/bildung/ausbildung')">
                  <label for="ausbildung">Ausbildung</label>
                </div>
                <div class="radio-wrapper right-wrapper-50">
                  <input id="studium" :checked="educationIndex === 2" type="radio" name="education" value="2" class="radio" @change="(e) => onSelectEducation(e, '02/bildung/studium')">
                  <label for="studium">Studium</label>
                </div>
                <div v-if="cardIndex === 3" class="radio-wrapper right-wrapper-50">
                  <input id="Berufsanfänger" :checked="educationIndex === 3" type="radio" name="education" value="3" class="radio" @change="(e) => onSelectEducation(e, '02/bildung/berufsanfaenger')">
                  <label for="Berufsanfänger">Berufsanfänger</label>
                </div>
              </div>
            </div>
            <hr>
          </div>
        </template>
      </div>
      <!-- stop row -->

      <!-- start row: favorite cards -->
      <a ref="recommend" />
      <div v-if="insurances.length > 0" class="row tk-vkb-fullsizebg1 tk-vkb-expand">
        <div class="wrapper-spacing large-12 medium-12 small-12 columns">
          <div class="row">
            <div class="small-12 columns">
              <h2>Empfohlene Versicherungen</h2>
              <hr class="topspace">
            </div>
          </div>
          <div class="row tk-vkb-flex-container">
            <div v-for="(insurance, index) in insurances" :key="index" class="tk-vkb-cardspace small-12 medium-6 large-4 columns tk-vkb-flex-wrapper">
              <!-- <insurance-card
                :name="insurance.name"
                :icon="insurance.icon"
                :html="decodeHtml(insurance.html)"
                :link-more="insurance.more_info_url"
                :link-calc="insurance.calculate_online_url"
                :link-compare="insurance.compare_tariff_url"
                :is-favorite="insurance.is_favorite"
                @favorite="onSelectInsurance(index)"
              /> -->
              <insurance-card
                :name="insurance.name"
                :icon="insurance.icon"
                :html="decodeHtml(insurance.html)"
                :link-more="insurance.more_info_url"
                :link-calc="insurance.calculate_online_url"
                :link-compare="insurance.compare_tariff_url"
                :hide-favorite="true"
                @click-calc="triggerActionEvent(`03/empfehlung/beitrag_berechnen/${ insurance.internal_code }`, trackingModuleType)"
                @click-tarife="triggerActionEvent(`03/empfehlung/tarifvergleich/${ insurance.internal_code }`, trackingModuleType)"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- stop row: favorite cards -->

      <!-- start row: favorite list -->
      <!-- <div v-if="insurances.length > 0" class="row">
        <div class="wrapper-spacing large-5 medium-6 small-12 columns">
          <h2 class="topmargin-highlight">Deine Favoriten</h2>
          <ul class="cards-action-list">
            <template v-for="(insurance, index) in insurances">
              <li v-if="insurance.is_favorite" :key="insurance.id">
                <a class="h4">{{ insurance.name }}</a>
                <span class="cards-action cards-favorite active" @click="onRemoveFavorite(index)">
                  <i class="fo"><span class="hint">Entfernen</span></i>
                </span>
              </li>
            </template>
          </ul>
        </div>

        <div class="wrapper-spacing large-6 large-offset-1 medium-6 small-12 columns tk-vkb-bg1">
          <div class="highlight">
            <h2>Favoriten per E-Mail zuschicken</h2>
            <div class="row">
              <div class="small-12 columns topspace">
                <label class="padding-top" for="my-email">E-Mail-Adresse</label>
              </div>
              <div class="large-10 medium-10 small-10 columns topspace">
                <input id="my-email" v-model="emailAddress" class="input-block" type="text" name="my-email" @input="(e) => setEmailAddress(e.target.value)">
              </div>
              <div class="large-2 medium-2 small-2 columns topspace">
                <span :class="['feedback-after', {'validated': !$v.$invalid}]"/>
              </div>
              <div v-if="$v.$invalid && showError" class="small-12 columns hint-wrapper">
                <div v-if="!$v.emailAddress.email" class="hint error open">
                  <p>Ungültige E-Mail-Adresse.</p>
                </div>
                <div v-if="!$v.emailAddress.required" class="hint info open">
                  <p>Bitte geben Sie die E-Mail Adresse ein.</p>
                </div>
              </div>
              <div class="small-12 columns topspace">
                <input id="my-checkbox" :checked="agreeChecked" type="checkbox" name="checkbox-demo" @change="onCheckAgree">
                <label for="my-checkbox">
                  Durch die Angabe meiner E-Mail-Adresse stimme ich zu, dass diese zum Versand der markierten
                  Versicherungsinformationen verwendet werden darf*
                </label>
              </div>
              <div class="small-12 columns topspace">
                <div class="padding-checkbox">
                  <button :class="['button call-to-action', {'disabled': !agreeChecked || mailRequestSent}]" @click.prevent="sendEmail">
                    <i class="fo fo-email"/>
                    <span>Jetzt abschicken</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="favorite_count > 0" class="wrapper-spacing small-12 medium-12 large-8  columns tk-vkb-notopspace large-offset-2">
          <div>
            <div class="textmodule">
              <div class="paragraphs">
                <div>
                  <sup>*Die von Ihnen angegebenen Kommunikationsdaten und markierten Informationswünsche werden nur kurzzeitig gespeichert um Ihnen die gewünschten Informationen umgehend zukommen zu lassen. Nach Versand werden diese Daten vollständig gelöscht, eine Weitergabe an Dritte erfolgt zu keinem Zeitpunkt.</sup>
                </div>
                <div>
                  <sup>Die vollständigen Datenschutzinformation unseres Unternehmens finden Sie unter: <a :href="disclimer_url" class="arrow" title="Zu unseren Datenschutzbestimmungen" btattached="true">{{ disclimer_url }}</a></sup>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- stop row: favorite list -->
    </div>
  </div>
</template>

<script>
import Logic from './logic.js';
// import BerateDich from '@/apps/berate_dich/vkb';

export default {
  name: 'jule_2018_vkb',

  // components: {
  //   BerateDich
  // },

  mixins: [
    Logic,
  ],

  created() {
    window.addEventListener('scroll', this.onScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/jule_2018/fsoel.vue